module.exports = __webpack_public_path__ + "img/voltaje_c_gray.d8d67da5.svg";